module.exports = __webpack_public_path__ + "img/topind-logo.50610c5e.svg";